<mat-card>
  <mat-card-header>
    <mat-card-title>Не найдены производители ({{ brands.length }})</mat-card-title>
  </mat-card-header>
  <mat-list role="list">
    <mat-list-item *ngFor="let brand of brands" role="listitem">
      <app-upload-brand-result-item [brand]="brand.brand"></app-upload-brand-result-item>
    </mat-list-item>
  </mat-list>
</mat-card>
